/*
 * @Author: wp
 * @Date: 2023-01-04 16:06:42
 * @Descripttion:
 */
import Vue from 'vue'
import VueQr from 'vue-qr'
Vue.use(VueQr)
